import { Grid } from '@material-ui/core';
import { CardsStyle } from './CardsStyle';
import { useGetClientsQuery } from 'features/clients/clientSlice';
import LoadingSpinner from 'components/LoadingSpinner';
import SvgIconQRCode from 'icons/IconQRCode';
import ListComponent from './Lists/ListComponent';
import { IconLot, IconVehicle } from 'icons';
import PocInfo from './POC/PocInfo';
import EditSites from './Lists/EditListsComponents/EditSites';
import EditVehicles from './Lists/EditListsComponents/EditVehicles';
import SiteListItem from './Lists/ListItems/SiteListItem';
import VehicleListItem from './Lists/ListItems/VehicleListItem';
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import Authorize from 'components/Authorize';

const ClientAccessCard = ({ access }) => {

    const classes = CardsStyle()
    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery(null);
    const clientAccounts = clients?.flatMap(c => c.clientAccounts);

    const clientLookup = clientAccounts?.reduce(function (map, obj) {
        map[obj.id] = obj;
        return map;
    }, {});

    access = {
        ...access,
        clientName: clientLookup?.[access?.clientAccountId]?.name
    }

    return (
        <>
            <div className={classes.loadBox}>
                <LoadingSpinner loading={isLoadingClients} />
                <Grid container direction='row' >
                    <Grid item container direction='row' className={classes.cardItemIcon}>
                        <div item className={classes.title}><SvgIconQRCode /></div>
                    </Grid>
                    <Authorize profile={permissionProfiles.ACCESS.CLIENT_FIELDS}>
                        <Grid item container direction='column' className={classes.cardItem} >
                            <Grid item className={classes.data}>
                                <label className={classes.title}>Client: </label>
                                <label className={classes.data}>{access?.clientName}</label>
                            </Grid>
                        </Grid>
                    </Authorize>

                    <PocInfo access={access} />

                </Grid>

                <Grid container direction='row' spacing={2} className={classes.lists}>
                    <Grid item>
                        <ListComponent
                            access={access}
                            list={access?.lots}
                            listTitle='Sites'
                            listItem={(lot) => <SiteListItem access={access} lot={lot} />}
                            addComponent={(access, open, onClose) => <EditSites access={access} open={open} onClose={onClose} />}
                        />
                    </Grid>
                    <Grid item>
                        <ListComponent
                            access={access}
                            list={access?.vehicles}
                            listTitle='Vehicles'
                            listItem={(vehicle) => <VehicleListItem access={access} vehicle={vehicle} />}
                            addComponent={(access, open, onClose) => <EditVehicles access={access} open={open} onClose={onClose} />}
                        />
                    </Grid>
                </Grid>
            </div >
        </>
    );
}

export default ClientAccessCard



